<template>
    <div>
        <div class="wrapper-tfb-details animated fadeIn">
            <div class="card fts-table-wrapper">
                <div class="card-body">
                    <div class="sidebar-left">
                        <div class="upper">
                            <h3>ID {{queueID}}</h3>

                            <div class="header">
                                <span>Client</span>
                            </div>

                            <div class="clientdetails">
                                <span>{{companyDetails.companyName}}</span>
                                <span>{{companyDetails.address.address1}}</span>
                                <span>{{companyDetails.address.address2}}</span>
                                <span>{{companyDetails.address.postalCode}} {{companyDetails.address.city}} {{companyDetails.address.country}}</span>
                            </div>

                            <div class="clientcontact">
                                <span>Contact Number</span>
                                <strong>{{companyDetails.address.phoneNumber.asString}}</strong>
                            </div>
                        </div>

                        <div class="down">
                            <b-button @click="tryAgainTransaction()" variant="primary" :class="['reprocess', (this.errorStatusTransaction > 0) ? '' : 'grayout']" v-b-tooltip.hover title="Re-Process Magenta Activation Transaction">
                                Re-Process<i class="fa fa-refresh"></i>
                            </b-button>
                            <b-button :class="[(!transactionDetails.ban && !transactionDetails.dealerCode) ? '' : 'grayout']" @click="showTFBModal" variant="primary">Assign Ban & Dealer</b-button>
                        </div>
                    </div>

                    <div class="content">
                        <div class="header-line">
                            <router-link to="/admin/tfb-queue" class="btn btn-link"> <i class="fa fa-close"></i></router-link>
                        </div>

                        <div class="fts-table table-responsive-sm">
                            <table  v-if='transactionList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment">
                                <thead role="rowgroup">
                                    <tr role="row">
                                        <th role="columnheader" aria-colindex="2" aria-label="SIM">SIM</th>
                                        <th role="columnheader" aria-colindex="3" aria-label="MSISDN" aria-sort="none">MSISDN</th>
                                        <th v-on:click="changesSort" role="columnheader" aria-colindex="4" aria-label="BAN Number" aria-sort="none">BAN Number</th>
                                        <th v-on:click="changesSort" role="columnheader" aria-colindex="5" aria-label="Dealer Code" aria-sort="none">Dealer Code</th>
                                        <th v-on:click="changesSort" role="columnheader" aria-colindex="6" aria-label="Status" aria-sort="none">Status</th>
                                        <th role="columnheader" aria-colindex="7" aria-label="Internal TMO Reference">Internal TMO Reference</th>
                                        <th role="columnheader" aria-colindex="8" aria-label="Internal TMO Status">Internal TMO Status</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, index) in transactionList" :data-iccid="index" v-bind:key="index">
                                        <td>{{index}}</td>
                                        <td>{{item.msisdn}}</td>
                                        <td><span v-if="banNumber != 'not-assigned'">{{banNumber}}</span><span v-else>-</span></td>
                                        <td><span v-if="dealerNumber != 'not-assigned'">{{dealerNumber}}</span><span v-else>-</span></td>
                                        <td>{{item.status}}</td>
                                        <td>{{item.reference}}</td>
                                        <td>{{item.message}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="fts-bottom-table">
                            <router-link to="/admin/tfb-queue" class="btn btn-secondary">Back</router-link>
                            <b-button variant="primary" :class="[(!transactionDetails.ban && !transactionDetails.dealerCode) ? '' : 'grayout']" :disabled="dealerNumber == 'not-assigned' || banNumber == 'not-assigned'" @click="assignDeatilsToOrder">Activate</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="tfb-modal" ref="tfb-modal" size="lg" hide-footer hide-header centered>
            <b-button variant="link" class="hide-tfb-modal" @click="$refs['tfb-modal'].hide()">
                <i class="fa fa-close"></i>
            </b-button>
            <div class="left-side">
                <h3>BAN number and Dealer code</h3>

                <div class="header">
                    <span>BAN Number</span>
                </div>

                <div class="ban-wrapper">
                    <div :class="['ban-item', (banNumber == 'not-assigned') ? 'active' : '']">
                        <div class="radio fts-radio">
                            <input type="radio" name="ban-number" v-model="banNumber" id="noBanNumber" value="not-assigned">
                            <label for="noBanNumber"></label>
                        </div>
                        <label for="noBanNumber" class="value">
                            <span></span>
                            <strong>NOT ASSIGNED</strong>
                        </label>
                    </div>

                    <div :class="['ban-item', (banNumber == ban.id) ? 'active' : '']" v-for="(ban, index) in banList" v-bind:key="ban.id">
                        <div class="radio fts-radio">
                            <input type="radio" name="ban-number" v-model="banNumber" :id="`banNumber${index}`" :value="ban.id">
                            <label :for="`banNumber${index}`"></label>
                        </div>
                        <label :for="`banNumber${index}`" class="value">
                            <span>{{ban.displayName}}</span>
                            <strong>{{ban.id}}</strong>
                        </label>
                    </div>
                </div>
            </div>
            <div class="right-side">
                <div class="header-line">
                    <h3>Dealer Code</h3>
                </div>
                <div class="search-line">
                    <div class="input-group">
                        <input type="text" placeholder="Search" v-model="filterModal" @keyup="searchModalKeyUp" @keydown="searchModalKeyDown" class="form-control">
                    </div>
                </div>
                <div class="list-dealer">
                    <div :class="['dealer-item', (dealerNumber == 'not-assigned') ? 'active' : '']">
                        <div class="radio fts-radio">
                            <input type="radio" name="dealer-number" v-model="dealerNumber" id="notassigneddealer" value="not-assigned">
                            <label for="notassigneddealer"></label>
                        </div>
                        <label for="notassigneddealer" class="value">
                            <div class="dealer-name">
                                <span class="name"></span>
                                <strong>NOT ASSIGNED</strong>
                            </div>
                            <div class="dealer-code">
                                <span class="name"></span>
                                <strong></strong>
                            </div>
                        </label>
                    </div>

                    <div :class="['dealer-item', (dealerNumber == dealer.id) ? 'active' : '']" v-for="(dealer, index) in dealerList" v-bind:key="dealer.id">
                        <div class="radio fts-radio">
                            <input type="radio" name="dealer-number" v-model="dealerNumber" :id="`dealerNumber${index}`" :value="dealer.id">
                            <label :for="`dealerNumber${index}`"></label>
                        </div>
                        <label :for="`dealerNumber${index}`" class="value">
                            <div class="dealer-name">
                                <span class="name">Dealer</span>
                                <strong>{{dealer.displayName}}</strong>
                            </div>
                            <div class="dealer-code">
                                <span class="name">Dealer Code</span>
                                <strong>{{dealer.id}}</strong>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="buttons-wrap">
                    <b-button variant="secondary" @click="$refs['tfb-modal'].hide()">Cancel</b-button>
                    <b-button variant="primary" :disabled="dealerNumber == 'not-assigned' || banNumber == 'not-assigned'" @click="$refs['tfb-modal'].hide()">Assign</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
import globalStore from '../../variables'
import Paginate from 'vuejs-paginate'

export default {
    name: 'TFBDetaiils',
    data() {
        return {
            queueID: this.$route.params.id,
            filter: '',
            sortSettings: {
                page: 1,
                size: 10,
                sort: 1,
                desc: true
            },
            transactionList: [],
            selectedSims: 0,
            paginationCount: 0,
            searchString: '',
            banNumber: 'not-assigned',
            dealerNumber: 'not-assigned',
            dealerList: [],
            banList: [],
            filterModal: '',
            transactionDetails: '',
            companyDetails: {
                address: [
                    [

                    ]
                ]
            },
            counterList: 0,
            errorStatusTransaction: 0,
            interval: '',
        }
    },
    methods: {
        tryAgainTransaction() {
            Axios.patch(`${globalStore.data.restApiUrl}/queues/activations/${this.queueID}/replay`)
                .then(response => {
                    if (response.status == '204') {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Transaction was sended',
                            text: `Transaction Number ${this.queueID} Has Been Submitted for Re-Processing`,
                            duration: 5000,
                        });
                        setTimeout(() => {
                            this.getDetailsQueue()
                        }, 2000)
                    }
                }).catch(error => {
                    if (error.response.status == '404') {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Transaction Cannot be Re-Processed',
                            text: 'Error Re-Processing TFB Transaction',
                            duration: 5000,
                        });
                    }

                    if (error.response.status == '409') {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Transaction Cannot be Re-Processed',
                            text: 'Error Re-Processing TFB Transaction',
                            duration: 5000,
                        });
                    }
                })
        },
        getDetailsQueue() {
            let checkDetailsQueue = 0;
            Axios.get(`${globalStore.data.restApiUrl}/queues/activations/${this.queueID}`)
                .then(response => {

                    this.transactionDetails = response.data;
                    this.transactionList = this.transactionDetails.msisdnMap

                    for (let item in this.transactionList) {
                        if (this.transactionList[item].reference == undefined) {
                            this.transactionList[item].reference = '-';
                        }

                        if (this.transactionList[item].message == undefined) {
                            this.transactionList[item].message = '-';
                        }
                    }


                    let testArra = this.transactionList;

                    for (const item in this.transactionList) {
                        if (this.transactionList[item]['status'] == 'PROCESSED_ERROR') {
                            this.errorStatusTransaction++
                        }
                    }

                    if (this.transactionDetails.ban) {
                        this.banNumber = this.transactionDetails.ban
                    }

                    if (this.transactionDetails.dealerCode) {
                        this.dealerNumber = this.transactionDetails.dealerCode
                    }

                    if (this.transactionDetails.state == "AWAITING_PROCESSING" || this.transactionDetails.state == "IN_PROCESSING" || this.transactionDetails.state == "NEW") {
                        checkDetailsQueue++
                    }

                    if (checkDetailsQueue > 0) {
                        this.checkInterval();
                    }

                    this.getCompanyDetails(response.data.companyId)

                }).catch(error => {
                     this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving TFB Transaction List  - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        checkInterval() {
            if (this.$router.currentRoute.name == 'TFBQueueDetails') {
                setTimeout(() => {
                    this.getDetailsQueue();
                }, 5000)
            } else {
                clearInterval(this.interval)
            }
        },
        searchRow() {

        },
        showTFBModal() {
            this.$refs['tfb-modal'].show()
        },
        sizePage() {},
        changesSort() {},
        searchModalKeyUp() {
            clearTimeout(this.modalSearchTimer)
            this.modalSearchTimer = setTimeout(() => {
                this.searchOnList()
            }, 500)
        },
        searchModalKeyDown() {
            clearTimeout(this.modalSearchTimer)
        },
        searchOnList() {
            if (this.filterModal.length > 0) {
                this.searchString = `?search=${this.filterModal}`
            } else {
                this.searchString = ''
            }
            this.getOptionsOrder();
        },
        getOptionsOrder() {
            Axios.get(`${globalStore.data.restApiUrl}/tfb/signoff-params${this.searchString}`)
                .then(response => {
                    this.dealerList = response.data.dealerCodes
                    this.banList = response.data.bans
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Something was wrong in getting data from database. Please contact with support.',
                        duration: 5000,
                    });
                    console.log(response)
                })
        },
        assignDeatilsToOrder() {
            let arrToSend = {
                ban: this.banNumber,
                dealerCode: this.dealerNumber
            }

            const orderID = this.queueID;

            Axios.patch(`${globalStore.data.restApiUrl}/queues/activations/${orderID}/sign-off?companyId=${this.transactionDetails.companyId}`, arrToSend)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Activation was success',
                        text: 'Activation was success, order is pushed to process.',
                        duration: 5000,
                    });
                    this.$router.push('/admin/tfb-queue');
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Something was wrong in getting data from database. Please contact with support.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        getCompanyDetails(id) {
            Axios.get(`${globalStore.data.restApiUrl}/account?companyId=${id}`)
                .then(response => {
                    this.companyDetails = response.data;
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving Company Details - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        }
    },
    created() {
        this.getOptionsOrder()
        this.getDetailsQueue()
    },
    beforeDestroy() {
        clearTimeout(this.interval);
    }
}
</script>


<style lang="scss">
.wrapper-tfb-details {
    .fts-table-wrapper {
        padding-bottom: 0;

        .card-body {
            padding: 0;
        }
    }
    .card-body {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        min-height: 81vh;
        .sidebar-left {
            width: 20%;
            max-width: 218px;

            display: flex;
            flex-direction: column;
            justify-content: space-between;

            border-right: 1px solid #F0F3F5;

            .upper {
                >h3 {
                    padding: 25px 21px 19px;
                    font-size: 15px;
                    line-height: 21px;
                    font-weight: 700;
                    color: #000000;
                }

                .header {
                    padding: 18px 21px 22px;
                    background-color: #F0F3F5;
                    font-size: 15px;
                    line-height: 18px;
                    font-weight: 700;
                    color: #000;
                }

                .clientdetails {
                    padding: 20px;
                    font-size: 14px;
                    line-height: 24px;
                    font-weight: 700;

                    span {
                        display: block;
                    }
                }

                .clientcontact {
                    padding: 0 20px 20px;

                    span {
                        display: block;
                        margin-bottom: 5px;
                        font-size: 14px;
                        line-height: 24px;
                        font-weight: 400;
                    }
                }
            }

            .down {
                padding: 20px;

                button.reprocess {
                    margin-bottom: 20px;
                    i {
                        margin-left: 20px;
                    }
                }
            }
        }

        .content {
            width: 100%;
            position: relative;

            .header-line {
                display: flex;
                padding: 0 0 10px;
                justify-content: flex-end;

                a {
                    i {
                        color: #2F353A;
                    }
                }
            }

            .search-row {
                padding: 10px 20px 11px;
                border-bottom: 1px solid #F0F3F5;
                overflow: hidden;

                .size-page-wrapper {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    align-content: center;

                    label {
                        margin: 0;
                        margin-right: 10px;
                    }

                    select {
                        max-width: 100px;
                    }
                }
            }

            .fts-bottom-table {
                position: static;
                justify-content: flex-end;

                a {
                    margin-right: 10px;
                }
            }
        }
    }

    .table-tfb-details {
        tr {
            th {
                &:last-child {
                    width: 360px;
                }
            }
        }
    }
}

#tfb-modal___BV_modal_outer_ {
    .modal-body {
        position: relative;
        display: flex;
        justify-content: space-between;
        padding: 0;

        .hide-tfb-modal {
            position: absolute;
            right: 0;
            top: 0;
            i {
                margin-right: 0;
                color: #2F353A;
            }
        }

        .left-side {
            width: 100%;
            max-width: 270px;
            border-right: 2px solid #F0F3F5;

            >h3 {
                padding: 24px 20px 19px;
                font-size: 15px;
                line-height: 21px;
                font-weight: 700;
            }

            .header {
                padding: 18px 20px 22px;
                background-color: #F0F3F5;
                font-size: 15px;
                line-height: 18px;
                font-weight: 700;
            }

            .ban-wrapper {
                padding: 20px;

                .ban-item {
                    display: flex;
                    min-height: 76px;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 20px;
                    margin-bottom: 8px;

                    background-color: #F2F2F2;
                    border: 1px solid #C9CFD4;
                    border-radius: 5px;

                    .radio {
                        width: 100%;
                        max-width: 16px;

                        input[type="radio"] {
                            display: none;

                            &:checked + label::after {
                                content: '';
                                display: block;
                                position: absolute;
                                left: 4px;
                                top: 4px;
                                width: 8px;
                                height: 8px;
                                background-color: #2F353A;
                                border-radius: 50%;
                            }
                        }

                        label {
                            position: relative;
                            margin: 0;

                            &::before {
                                content: '';
                                display: block;
                                width: 16px;
                                height: 16px;
                                border: 2px solid #2F353A;
                                border-radius: 50%;
                            }
                        }
                    }

                    .value {
                        width: 100%;
                        padding-left: 20px;
                        margin: 0;
                        box-sizing: border-box;

                        span {
                            display: block;
                        }

                        strong {
                            display: block;
                        }
                    }
                }
            }
        }

        .right-side {
            width: 100%;

            .header-line {
                h3 {
                    padding: 24px  20px 19px;
                    font-size: 15px;
                    line-height: 21px;
                    font-weight: 700;
                }
            }

            .search-line {
                padding: 11px 20px;
                border: 1px solid #C9CFD4;

                input {
                    max-width: 345px;
                }
            }

            .list-dealer {
                padding: 20px 20px 0 20px;
                max-height: 521px;
                overflow-y: scroll;

                .dealer-item {
                    display: flex;
                    min-height: 76px;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 20px;
                    margin-bottom: 8px;

                    background-color: #F2F2F2;
                    border: 1px solid #C9CFD4;
                    border-radius: 5px;

                    &.active {
                        background-color: #fff;
                    }

                    .radio {
                        width: 100%;
                        max-width: 16px;

                        input[type="radio"] {
                            display: none;

                            &:checked + label::after {
                                content: '';
                                display: block;
                                position: absolute;
                                left: 4px;
                                top: 4px;
                                width: 8px;
                                height: 8px;
                                background-color: #2F353A;
                                border-radius: 50%;
                            }
                        }

                        label {
                            position: relative;
                            margin: 0;

                            &::before {
                                content: '';
                                display: block;
                                width: 16px;
                                height: 16px;
                                border: 2px solid #2F353A;
                                border-radius: 50%;
                            }
                        }
                    }

                    .value {
                        width: 100%;
                        padding-left: 20px;
                        margin: 0;
                        box-sizing: border-box;
                        display: flex;

                        .dealer-name {
                            width: 100%;
                            max-width: 170px;
                        }

                        span {
                            display: block;
                        }

                        strong {
                            display: block;
                        }
                    }
                }
            }

            .buttons-wrap {
                display: flex;
                justify-content: flex-end;
                padding: 20px;

                button {
                    margin-left: 10px;
                }
            }
        }
    }
}
.grayout {
    opacity: 0.4;
    pointer-events: none !important;
}
    .dark-theme {
        .wrapper-tfb-details  {
            .card {
                .sidebar-left {
                    border-right-color: #2f353a;
                    .upper {
                        h3 {
                            color: #edeeef;
                        }
                        .header {
                            background-color: #2f353a;
                            color: #edeeef;
                        }
                    }
                }
                .content {
                    .header-line,
                    .search-row {
                        border-color: #2f353a;
                    }
                    .search-row {
                        .form-control {
                            background-color: #515b65;
                            border-color: #1a1c1d;
                            color: #edeeef;

                            &::placeholder {
                                color: #edeeef;
                            }
                        }
                    }

                    .table thead th {
                        color: #fff;
                        border-color: #1A1C1D;
                    }
                    .table tbody tr td {
                        border-color: #1A1C1D;
                        color: #fff;
                    }
                    .table tbody tr:nth-of-type(even) td {
                        background-color: #3a4149;
                    }
                    .table tbody tr:nth-of-type(odd) td {
                        background-color: #2F353A;
                    }
                    .table tbody tr:hover td {
                        background-color: #0088FF;
                        color: #fff;
                    }
                    .table tbody tr[aria-selected="true"] td {
                        background-color: #0088FF;
                        color: #fff;
                    }
                }
            }
        }



        #tfb-modal___BV_modal_outer_ {
            .modal-content {
                .modal-body {
                    background-color: #3a4149;
                    color: #edeeef;
                    .left-side {
                        border-color: #2f353a;
                        .header {
                            background-color: #2f353a;
                        }
                        .ban-wrapper {
                            .ban-item {
                                background-color: #2f353a;
                                border-color: #1a1c1d;


                                &.active {
                                    background-color: #bfe1ff;
                                    color: #1a1c1d;


                                    .radio {
                                        input[type="radio"] {
                                            display: none;

                                            &:checked + label::after {
                                                background-color: #1a1c1d;
                                            }
                                        }

                                        label {

                                            &::before {
                                                border: 2px solid #1a1c1d;
                                            }
                                        }
                                    }
                                }


                                .radio {
                                    input[type="radio"] {
                                        display: none;

                                        &:checked + label::after {
                                            content: '';
                                            display: block;
                                            position: absolute;
                                            left: 4px;
                                            top: 4px;
                                            width: 8px;
                                            height: 8px;
                                            background-color: #fff;
                                            border-radius: 50%;
                                        }
                                    }

                                    label {
                                        position: relative;
                                        margin: 0;

                                        &::before {
                                            content: '';
                                            display: block;
                                            width: 16px;
                                            height: 16px;
                                            border: 2px solid #edeeef;
                                            border-radius: 50%;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .right-side {
                        .search-line {
                            border-color: #2f353a;
                            .form-control {
                                background-color: #515b65;
                                border-color: #1a1c1d;
                                color: #edeeef;

                                &::placeholder {
                                    color: #edeeef;
                                }
                            }
                        }
                        .list-dealer {
                            .dealer-item {
                                background-color: #2f353a;
                                border-color: #1a1c1d;

                                &.active {
                                    background-color: #bfe1ff;
                                    color: #1a1c1d;


                                    .radio {
                                        input[type="radio"] {
                                            display: none;

                                            &:checked + label::after {
                                                background-color: #1a1c1d;
                                            }
                                        }

                                        label {

                                            &::before {
                                                border: 2px solid #1a1c1d;
                                            }
                                        }
                                    }
                                }


                                .radio {
                                    input[type="radio"] {
                                        display: none;

                                        &:checked + label::after {
                                            background-color: #fff;
                                        }
                                    }

                                    label {

                                        &::before {
                                            border: 2px solid #edeeef;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
